import React, { useEffect } from "react"
import styles from "./styles.module.scss"

const Footer = () => <footer className={styles.Footer}>
  <a href="mailto:marcin3755@gmail.com">Designed with precision in Poland</a>
</footer>


export default Footer